'use client';

import useForkRef from '@mui/utils/useForkRef';
export default useForkRef;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useForkRef.js
// module id = 47
// module chunks = 25